const feeRuleRoutes = [
    { path: '/classifyManagement', name: 'classifyManagement', component: () => import('../../views/feeRules/ClassifyManagement.vue'), meta: { title: '物品分类管理' } },
    { path: '/tianyiPriceManagement', name: 'tianyiPriceManagement', component: () => import('../../views/feeRules/TianyiPriceManagement.vue'), meta: { title: '天翼费用管理' } },
    {
        path: '/serviceRuleManagement',
        name: 'serviceRuleManagement',
        component: () => import('../../views/feeRules/ServiceRuleManagement.vue'),
        meta: { title: '服务类规则管理' }
    },
    {
        path: '/materialChargeRule',
        name: 'materialChargeRule',
        component: () => import('../../views/feeRules/MaterialChargeRule.vue'),
        meta: { title: '物料收费规则' }
    }
]

export default feeRuleRoutes

